import GSAP from 'gsap'
import Close from '../../../assets/icons/close.svg'
import logo from '../../../assets/icons/logo.png'
import Video from './Video'

export default class Projets {
  constructor() {
    //setup
    this.menuLink = document.querySelector('.tvPoint')
    this.tl = new GSAP.timeline({ paused: true, reversed: true })
    this.music = document.querySelector('.music')
    this.btnAudio = document.querySelector('.btnAudio')

    //Method
    this.createPage()
    this.createVideo()
    this.closePage()
    this.event()
  }
  createPage() {
    //Page
    this.page = document.createElement('div')
    this.page.classList.add('projets')
    document.body.appendChild(this.page)

    //Page Wrapper
    this.pageWrapper = document.createElement('div')
    this.pageWrapper.className = 'page_wrapper'
    this.pageWrapper.dataset.scroll = 'data-scroll'
    this.page.appendChild(this.pageWrapper)

    //Page content
    this.pageContent = document.createElement('div')
    this.pageContent.className = 'page_content'
    this.pageWrapper.appendChild(this.pageContent)

    //Image
    this.pageImage = document.createElement('img')
    this.pageImage.className = 'notion_img'
    this.pageImage.src = logo
    this.pageContent.appendChild(this.pageImage)

    //image
    this.pageDescription = document.createElement('p')
    this.pageDescription.innerHTML = 'Retrouvez une sélection de mon travail sur Notion'
    this.pageContent.appendChild(this.pageDescription)

    //button
    this.pageNotionLink = document.createElement('a')
    this.pageNotionLink.setAttribute('target', '_blank')
    this.pageNotionLink.innerHTML = 'Découvrez les projets'
    this.pageNotionLink.className = 'notion_link'
    this.pageNotionLink.href = 'https://bush-peacock-fc8.notion.site/tude-de-cas-2fb14b68650149b499ab1108259508d2'
    this.pageContent.appendChild(this.pageNotionLink)

    //Close
    this.closeBtn = document.createElement('img')
    this.closeBtn.className = 'closePage'
    this.closeBtn.src = Close
    this.page.appendChild(this.closeBtn)
  }
  createVideo() {
    this.video = new Video()
    this.page.appendChild(this.video.videoElement)
    this.page.appendChild(this.video.videoControl)
  }
  playVideo() {
    if (this.video.videoElement.paused) {
      this.music.pause()
      this.video.videoElement.style.display = 'block'
      this.video.videoControl.style.display = 'block'
      this.video.videoElement.currentTime = 0
      this.video.videoElement.play()
      this.video.videoElement.volume = 0.25
      this.btnAudio.pause()
    } else {
      this.video.videoElement.pause()
      this.video.videoControl.style.display = 'none'
      this.video.videoElement.style.display = 'none'
      this.btnAudio.play()
    }
  }
  togglePage() {
    this.tl.to(this.page, {
      autoAlpha: 1,
      display: 'block',
      ease: 'Power1.easeOut',
      duration: 2,
    })
    this.tl.call(this.playVideo())
    this.tl.reversed() ? this.tl.play().timeScale(1) : this.tl.timeScale(1.5).reverse()
  }
  closePage() {
    this.closeBtn = document.querySelector('.closePage')
    this.closeBtn.addEventListener('click', () => {
      this.tl.timeScale(2).reverse()
    })
    this.page.addEventListener('click', () => {
      this.tl.timeScale(2).reverse()
    })
  }
  event() {
    this.menuLink.addEventListener('click', this.togglePage.bind(this), false)
  }
  update() {}
}
